export interface CategoryItem {
  id: string;
  name: string;
  slug: string;
  icon: string;
  description: string;
  image: string;
  count: number;
}

export const categories: CategoryItem[] = [
  {
    id: 'plush',
    name: '毛绒玩偶',
    slug: 'plush',
    icon: 'ri-heart-3-line',
    description: '软糯治愈的黄油小熊毛绒系列，从经典款到限定款，给你最温暖的拥抱。',
    image: 'https://readdy.ai/api/search-image?query=A%20group%20of%20cute%20warm%20yellow%20butter%20bear%20plush%20toys%20in%20different%20sizes%20sitting%20together%20on%20a%20cream%20colored%20shelf%2C%20soft%20fluffy%20texture%2C%20adorable%20expressions%2C%20warm%20natural%20lighting%2C%20kawaii%20collection%20display&width=600&height=400&seq=cat-plush-01&orientation=landscape',
    count: 3,
  },
  {
    id: 'accessories',
    name: '精致配饰',
    slug: 'accessories',
    icon: 'ri-star-line',
    description: '随身携带的黄油小熊小物，钥匙扣、手机壳、帆布包，让可爱时刻相伴。',
    image: 'https://readdy.ai/api/search-image?query=A%20flat%20lay%20of%20cute%20warm%20yellow%20butter%20bear%20accessories%20including%20keychains%20phone%20cases%20and%20small%20charms%2C%20arranged%20neatly%20on%20a%20cream%20surface%2C%20soft%20warm%20lighting%2C%20product%20photography&width=600&height=400&seq=cat-accessories-02&orientation=landscape',
    count: 3,
  },
  {
    id: 'home',
    name: '居家好物',
    slug: 'home',
    icon: 'ri-home-heart-line',
    description: '用黄油小熊装点你的家，抱枕、马克杯、小夜灯，让每个角落都充满温暖。',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20home%20setting%20with%20cute%20warm%20yellow%20butter%20bear%20themed%20home%20decor%20items%20including%20a%20cushion%20mug%20and%20night%20lamp%2C%20warm%20interior%20lighting%2C%20cream%20colored%20room%2C%20minimal%20kawaii%20lifestyle%20photography&width=600&height=400&seq=cat-home-03&orientation=landscape',
    count: 3,
  },
  {
    id: 'stationery',
    name: '文具手账',
    slug: 'stationery',
    icon: 'ri-pencil-ruler-2-line',
    description: '可爱又实用的黄油小熊文具，让学习和工作也变得充满期待。',
    image: 'https://readdy.ai/api/search-image?query=Cute%20warm%20yellow%20butter%20bear%20themed%20stationery%20items%20including%20notebooks%20pens%20and%20stickers%2C%20arranged%20on%20a%20cream%20wooden%20desk%2C%20soft%20warm%20lighting%2C%20kawaii%20study%20aesthetic&width=600&height=400&seq=cat-stationery-04&orientation=landscape',
    count: 1,
  },
  {
    id: 'collab',
    name: '联名限定',
    slug: 'collab',
    icon: 'ri-sparkling-2-line',
    description: '黄油小熊与各大品牌的精彩联名，每一款都是独特的设计珍藏。',
    image: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20limited%20edition%20cute%20warm%20yellow%20butter%20bear%20collaboration%20products%20from%20various%20brands%2C%20displayed%20on%20a%20cream%20surface%2C%20exclusive%20design%20items%2C%20soft%20warm%20lighting&width=600&height=400&seq=cat-collab-05&orientation=landscape',
    count: 2,
  },
  {
    id: 'collectible',
    name: '收藏臻品',
    slug: 'collectible',
    icon: 'ri-vip-crown-line',
    description: '值得珍藏的黄油小熊限定收藏品，盲盒、展示盒，满足收藏家的每一个期待。',
    image: 'https://readdy.ai/api/search-image?query=A%20premium%20display%20of%20cute%20warm%20yellow%20butter%20bear%20collectible%20figurines%20in%20an%20acrylic%20display%20case%20with%20warm%20LED%20lighting%2C%20collector%20showcase%2C%20soft%20cream%20background&width=600&height=400&seq=cat-collectible-06&orientation=landscape',
    count: 2,
  },
];